// TODO - COMPLETE THIS FUNCTION TO OBTAIN THE ERROR MESSAGE FROM API ERROR RESPONSE

export function getApiErrorMessage(
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  response: any,
  fallbackErrorMessage = 'Something went wrong'
) {
  return fallbackErrorMessage;
}
